@use '../../styling/form-controls.scss' as *;
@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

// Fill colors for a background SVG cannot be changed via CSS
// So we need a color variant of each
$arrow-down-svg-gray: url('../../styling/svg/ChevronDownGray.svg');
$arrow-up-svg-gray: url('../../styling/svg/ChevronUpGray.svg');
$arrow-down-svg-white: url('../../styling/svg/ChevronDownWhite.svg');

.GroupedSingleSelect {
  @extend %form-control-border;
  @extend %form-control-font;
  @extend %form-control-background;
  @extend %form-control-dropdown-disabled;
  @extend %form-control-select;

  background-color: $theme-color-table-header-background;
  font-size: $font-size-normal;
  font-weight: $font-weight-semibold;
  width: 100%;

  &.ArrowDown {
    background-image: $arrow-down-svg-gray;
    background-size: 17px;
  }

  &.ArrowUp {
    background-image: $arrow-up-svg-gray;
    background-size: 17px;
  }

  optgroup {
    color: $theme-color-text;
  }

  option {
    color: $theme-color-text;

    &:disabled,
    &[disabled] {
      color: $color-disabled-background;
    }
  }

  &:hover:enabled,
  &:focus:enabled {
    @extend %hover-focus-shadow;
  }

  &.isSolid {
    color: $color-white;
    background-image: $arrow-down-svg-white;
    background-size: 17px;
    background-color: $form-control-color;

    &:hover,
    &:active,
    &:focus {
      outline: none;
      border: 1px solid $form-control-color-hover;
      background-image: $arrow-down-svg-white, linear-gradient(to left, $form-control-color-hover 0%, $form-control-color-hover 100%);
    }

    &:disabled,
    &[disabled] {
      color: $color-white;
      background-image: $arrow-down-svg-white, linear-gradient(to left, $color-grey-A 24px, $color-grey-A 0);
      border: 1px solid $color-grey-A;
    }
  }
}
